module.exports = __webpack_public_path__ + "static/media/logoWhite.6d358b7d.png";